import React, { useState, useEffect } from "react";
import { Card, Modal, Row, Col, Spinner } from "react-bootstrap";
import { TailSpin } from "react-loader-spinner";

import { Link, useParams } from "react-router-dom";
import taleimg1 from "../../../assets/img/taleimg1.jpg";
import userlike1 from "../../../assets/img/avatars/2.png";
import userlike2 from "../../../assets/img/avatars/4.png";
import { getTaleDetail } from "../../../api/taleService";

const MEDIA_URL = "https://d3bn54rc14fhr4.cloudfront.net";

export default function Viewtale() {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const [comment, setComment] = useState(false);
  const [like, setLike] = useState(false);
  const [tale, setTale] = useState({});
  const [likesCount, setLikesCount] = useState(0);
  const [commentsCount, setCommentsCount] = useState(0);
  const [likes, setLikes] = useState([]);
  const [comments, setComments] = useState([]);

  const { taleId } = useParams();

  const videotoggle = () => setShow(!show);
  const commentToggle = () => setComment(!comment);
  const likeToggle = () => setLike(!like);

  useEffect(() => {
    if (taleId) {
      fetchTales(taleId);
    }
  }, [taleId]);

  const fetchTales = (taleId) => {
    setLoading(true);
    getTaleDetail({ taleId })
      .then((response) => {
        if (response.data) {
          const { taleDetail, likesCount, commentsCount, likes, comments } =
            response.data;
          setTale(taleDetail);
          setLikesCount(likesCount);
          setCommentsCount(commentsCount);
          setLikes(likes);
          setComments(comments);
        }
      })
      .catch((error) => console.error("Error fetching tale details", error))
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <React.Fragment>
      {loading ? (
        <div className="text-center py-5">
          <div
                        className="text-center py-5"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "120px",
                          width: "100%",
                        }}
                      >
                        <TailSpin height={50} width={80} color="#4fa94d" />
                      </div>
        </div>
      ) : (
        <Card>
          <Card.Header className="d-flex align-items-center justify-content-between flex-wrap">
            <h5>Tale Details</h5>
            <Link
              className="btn btn-primary-light d-inline-flex align-items-center justify-content-center px-4 min_width140"
              to="/tales"
            >
              Back
            </Link>
          </Card.Header>
          <Card.Body className="taledtl_div mt-3">
            <Row>
              <Col md="4">
                <div className="talefile_box">
                  <img
                    onClick={videotoggle}
                    className="talefile_img"
                    src={tale.file ? `${MEDIA_URL}/${tale.file}` : taleimg1}
                    alt="Tale"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = taleimg1;
                    }}
                  />
                </div>
              </Col>
              <Col md="8">
                <div className="talefile_list">
                  <div className="tablefilelist_grid">
                    <h4>Title</h4>
                    <p>{tale.title}</p>
                  </div>
                  <div className="tablefilelist_grid">
                    <h4>Description</h4>
                    <p>{tale.description}</p>
                  </div>
                  <div className="tablefilelist_grid">
                    <h4>Genre</h4>
                    <p>{tale.genre}</p>
                  </div>
                  <div className="tablefilelist_grid">
                    <h4>Likes</h4>
                    <p>
                      <Link className="taledtl_like_btn" onClick={likeToggle}>
                        {likesCount.toLocaleString()}
                      </Link>
                    </p>
                  </div>
                  <div className="tablefilelist_grid">
                    <h4>Comments</h4>
                    <p>
                      <Link
                        className="taledtl_like_btn"
                        onClick={commentToggle}
                      >
                        {commentsCount.toLocaleString()}
                      </Link>
                    </p>
                  </div>
                  <div className="tablefilelist_grid">
                    <h4>Username</h4>
                    <p>{tale.username}</p>
                  </div>
                  <div className="tablefilelist_grid">
                    <h4>Created At</h4>
                    <p>{new Date(tale.createdAt).toLocaleString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        })}</p>
                  </div>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      )}

      {/* Likes Modal */}
      <Modal className="modal_likes" show={like} onHide={likeToggle} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="modalhead">Likes</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="talelike_div">
            {likes.length > 0 ? (
              likes.map((like, index) => (
                <div key={index} className="talelike_box">
                  <img
                    className="img-thumbnail"
                    src={
                      like.profilePic
                        ? `${MEDIA_URL}/${like.profilePic}`
                        : userlike1
                    }
                    alt={like.username}
                  />
                  <h4>{like.username}</h4>
                </div>
              ))
            ) : (
              <p className="text-center text-muted">No Likes Found</p>
            )}
          </div>
        </Modal.Body>
      </Modal>

      {/* Comments Modal */}
      <Modal show={comment} size="lg" onHide={commentToggle} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            <h2 className="modalhead">Comments</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="talecomment_div">
            {comments.length > 0 && comments[0].comments.length > 0 ? (
              comments[0].comments.map((comment, index) => (
                <div key={comment._id} className="talecomment_thread">
                  <div className="talecomment_box">
                    <img
                      className="img-thumbnail"
                      src={
                        comment.profilePic
                          ? `${MEDIA_URL}/${comment.profilePic}`
                          : userlike1
                      }
                      alt={comment.username}
                    />
                    <div className="talecomment_cont">
                      <h4 className="taleuser_name">{comment.username}</h4>
                      <p className="taleuser_msg">{comment.commentText}</p>
                      <p className="taleuser_time">
                        {new Date(comment.createdAt).toLocaleString()}
                      </p>
                    </div>
                  </div>

                  {comment.replies &&
                    comment.replies.map((reply) => (
                      <div key={reply._id} className="talecomment_box ml_60">
                        <img
                          className="img-thumbnail"
                          src={
                            reply.profilePic
                              ? `${MEDIA_URL}/${reply.profilePic}`
                              : userlike2
                          }
                          alt={reply.username}
                        />
                        <div className="talecomment_cont">
                          <h4 className="taleuser_name">{reply.username}</h4>
                          <p className="taleuser_msg">{reply.commentText}</p>
                          <p className="taleuser_time">
                            {new Date(reply.createdAt).toLocaleString()}
                          </p>
                        </div>
                      </div>
                    ))}
                </div>
              ))
            ) : (
              <p className="text-center text-muted">No Comments Found</p>
            )}
          </div>
        </Modal.Body>
      </Modal>

      {/* Video Modal */}
      <Modal className="modal_video" show={show} onHide={videotoggle} centered>
        <Modal.Body>
          <iframe
            src="https://www.youtube.com/embed/D0UnqGm_miA?si=CZ49PDvs2j_dYMHE"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            title="Video Preview"
          ></iframe>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}
